import styles from "./Input.module.css";
import InputHeader from "./InputHeader";
import alertSVG from "../../../assets/alert.svg";
import InputCard from "../containers/InputCard";

/*
  Input element references:
  https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
  https://www.w3schools.com/html/html_form_input_types.asp
*/

const TextInput = ({
  label,
  img,
  placeholder,
  onChange,
  value,
  autocomplete = "off",
  type = "text",
  identifier,
  required,
  error,
  errorText,
  readonly = false,
}) => {
  let textInputclass = readonly ? styles.textInputReadonly : styles.textInput;
  return (
    <InputCard>
      <InputHeader required={required} text={label} />
      <div className={styles.textInputDiv}>
        {img && <img alt="" className={styles.textInputSvg} src={img} />}
        {error && (
          <img
            alt={errorText}
            title={errorText}
            className={styles.textInputSvg}
            src={alertSVG}
          />
        )}
        <input
          className={textInputclass}
          autoComplete={autocomplete}
          type={type}
          placeholder={placeholder}
          name={identifier}
          id={identifier}
          onChange={onChange}
          value={value}
          readOnly={readonly}
        />
      </div>
    </InputCard>
  );
};

export default TextInput;
